import type { FeedItem, FeedPage, GroupedFeed, LadderStepUi, Severity } from '../types/domain.types';

export const groupFeed = (items: readonly FeedItem[]): GroupedFeed => {
  const alerted: FeedItem[] = [];
  const held: FeedItem[] = [];
  const waiting: FeedItem[] = [];
  for (const item of items) {
    switch (item.state) {
      case 'ALERTED':
        alerted.push(item);
        break;
      case 'HELD':
        held.push(item);
        break;
      case 'WAITING':
        waiting.push(item);
        break;
      default: {
        const unhandled: never = item.state;
        throw new Error(`Feed state without a group: ${String(unhandled)}`);
      }
    }
  }
  return { alerted, held, waiting };
};

export const latestForIssue = (items: readonly FeedItem[], issueId: string): FeedItem | null =>
  items.find((item) => item.issueId === issueId) ?? null;

export const feedHasAlert = (items: readonly FeedItem[], issueId: string, step: LadderStepUi): boolean =>
  step !== 'UNKNOWN' && items.some((item) => item.issueId === issueId && item.step === step);

export const FEED_RENDER_LIMIT = 60;

export const capRows = <T,>(rows: readonly T[]): readonly T[] =>
  rows.length <= FEED_RENDER_LIMIT ? rows : rows.slice(0, FEED_RENDER_LIMIT);

export interface PreviewSplit<T> {
  readonly preview: readonly T[];
  readonly more: readonly T[];
}

export const splitPreview = <T,>(rows: readonly T[], size: number): PreviewSplit<T> => ({
  preview: rows.slice(0, size),
  more: rows.slice(size),
});

const NOTHING_HELD: Partial<Record<Severity, number>> = {};

export const heldTally = (page: FeedPage): Partial<Record<Severity, number>> => (page.quiet.active ? page.quiet.held : NOTHING_HELD);

export const heldItems = (items: readonly FeedItem[]): readonly FeedItem[] => items.filter((item) => item.state === 'HELD');
